import avatar from '@/assets/img/d_img.png'
import Is from 'is_js'
const wx = require('weixin-js-sdk');
const CallApp = require('callapp-lib');
var userAgent = (navigator && navigator.userAgent || '').toLowerCase();
// 时间戳转化时间
export function parseTime (time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date;
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  let time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime (time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

// 格式化时间
export function getQueryObject (url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

export function cleanArray (actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param (json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined) return ''
    return encodeURIComponent(key) + '=' +
      encodeURIComponent(json[key])
  })).join('&')
}

export function param2Obj (url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
}

export function html2Text (val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge (target, source) {
  /* Merges two  objects,
   giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  for (const property in source) {
    if (source.hasOwnProperty(property)) {
      const sourceProperty = source[property]
      if (typeof sourceProperty === 'object') {
        target[property] = objectMerge(target[property], sourceProperty)
        continue
      }
      target[property] = sourceProperty
    }
  }
  return target
}

export function scrollTo (element, to, duration) {
  if (duration <= 0) return
  const difference = to - element.scrollTop
  const perTick = difference / duration * 10
  setTimeout(() => {
    console.log(new Date())
    element.scrollTop = element.scrollTop + perTick
    if (element.scrollTop === to) return
    scrollTo(element, to, duration - 10)
  }, 10)
}

export function toggleClass (element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export const pickerOptions = [{
  text: '今天',
  onClick (picker) {
    const end = new Date()
    const start = new Date(new Date().toDateString())
    end.setTime(start.getTime())
    picker.$emit('pick', [start, end])
  }
}, {
  text: '最近一周',
  onClick (picker) {
    const end = new Date(new Date().toDateString())
    const start = new Date()
    start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
    picker.$emit('pick', [start, end])
  }
}, {
  text: '最近一个月',
  onClick (picker) {
    const end = new Date(new Date().toDateString())
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    picker.$emit('pick', [start, end])
  }
}, {
  text: '最近三个月',
  onClick (picker) {
    const end = new Date(new Date().toDateString())
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
    picker.$emit('pick', [start, end])
  }
}]

export function getTime (type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

// 防抖
export function debounce (func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

// 深拷贝
export function deepClone (source, hash = new WeakMap()) {
  if (!isObject(source)) return source
  if (hash.has(source)) return hash.get(source)

  let target = Array.isArray(source) ? [] : {}
  hash.set(source, target)

  let symKeys = Object.getOwnPropertySymbols(source)
  if (symKeys.length) {
    symKeys.forEach(symKey => {
      if (isObject(source[symKey])) {
        target[symKey] = deepClone(source[symKey], hash)
      } else {
        target[symKey] = source[symKey]
      }
    })
  }

  for (let key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (isObject(source[key])) {
        target[key] = deepClone(source[key], hash)
      } else {
        target[key] = source[key]
      }
    }
  }
  return target
}
// 判断类型
function isObject (obj) {
  return typeof obj === 'object' && obj != null
}

export function getUrlParam (name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

// build a 'comparator' object for various comparison checks
var comparator = {
  '<': function (a, b) {
    return a < b;
  },
  '<=': function (a, b) {
    return a <= b;
  },
  '>': function (a, b) {
    return a > b;
  },
  '>=': function (a, b) {
    return a >= b;
  }
}

// helper function which compares a version to a range
function compareVersion (version, range) {
  var string = (range + '');
  var n = +(string.match(/\d+/) || NaN);
  var op = string.match(/^[<>]=?|/)[0];
  return comparator[op] ? comparator[op](version, n) : (version == n || n !== n);
}

export function isWeixin () { // 判断是否是微信
  let ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}

// 是否是小程序环境
export function isApplet () {
  if (isWeixin()) {
    if (window.__wxjs_environment === 'miniprogram') { // 小程序环境下逻辑
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

export function throttle (fn, gapTime) { // 函数节流
  if (gapTime == null || gapTime == undefined) {
    gapTime = 1500
  }

  let _lastTime = null

  // 返回新的函数
  return function () {
    let _nowTime = +new Date()
    if (_nowTime - _lastTime > gapTime || !_lastTime) {
      fn.apply(this, arguments) // 将this和参数传给原函数
      _lastTime = _nowTime
    }
  }
}

export function getUrlStarParams (names) { // 处理微信多参数的方法
  let urlSearch = location.search;
  let urlValue = "";
  let params = urlSearch.split(/[?*&]/);
  for (let i = 0; i < params.length; i++) {
    // 如果url参数里包含传递过来names字段，则取=后面的部分
    if (params[i].indexOf(names) >= 0) {
      urlValue = params[i].split("=")[1];
      return urlValue;
    }
  }
  return urlValue;
}

// 转换时间
export function getDateTime (type, ms, separate, compatibility) {
  if (ms) {
    var myDate = new Date(ms * 1000)
  } else {
    var myDate = new Date()
  }
  // 获取当前年
  var year = myDate.getFullYear()
  // 获取当前月
  var month = myDate.getMonth() + 1
  // 获取当前日
  var date = myDate.getDate()
  var h = myDate.getHours() // 获取当前小时数(0-23)
  var m = myDate.getMinutes() // 获取当前分钟数(0-59)
  var s = myDate.getSeconds()
  var myddy = myDate.getDay()
  var weekday = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
  var week = weekday[myddy]
  var now = ''
  if (type == 'date') {
    if (compatibility) {
      now = year + '/' + sTime(month) + '/' + sTime(date)
    } else {
      now = year + '-' + sTime(month) + '-' + sTime(date)
    }
  } else if (type == 'yy') {
    now = year
  } else if (type == 'm') {
    now = month < 10 ? '0' + month : month
  } else if (type == 'd') {
    now = date < 10 ? '0' + date : date
  } else if (type == 'time') {
    now = h
  } else if (type == 'mm') {
    now = m
  } else {
    now = year + '-' + sTime(month) + '-' + sTime(date) + ' ' + sTime(h) + ':' + sTime(m) + ':' + sTime(s)
  }
  if (!separate) {
    return now
  } else {
    return {
      'year': year,
      'month': month,
      'date': date,
      'h': sTime(h),
      'm': sTime(m),
      's': sTime(s),
      'week': week
    }
  }
}

export function sTime (s) {
  return s < 10 ? '0' + s : s
}

// 头像处理(服务器头像，微信头像，默认头像)
export function portrait (prefix, p) {
  let head = "";
  if (!p) {
    head = avatar;
  } else if (p.indexOf("http") != -1) {
    head = p;
  } else {
    head = prefix + p;
  }
  return head;
}

export function isIphonX () {
  // iPhone X、iPhone XS
  var isIPhoneX = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812;
  // iPhone XS Max
  var isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896;
  // iPhone XR
  var isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896;
  return isIPhoneX || isIPhoneXR || isIPhoneXSMax
}
// App 跳登陆
export function appLogin () {
  if (window.webkit) { // IOS
    window.webkit.messageHandlers.pushToProductDetail.postMessage({
      pageType: 'login'
    })
    return false;
  }
  if (window.WebViewJavascriptBridge) { // Android
    window.WebViewJavascriptBridge.callHandler('pushToProductDetail', {
      pageType: 'login'
    })
    return false;
  }
}
// 小程序 跳登陆
export function appletLogin () {
  wx.miniProgram.getEnv(function (res) {
    let urlLink = `${window.location.href}`
    wx.miniProgram.navigateTo({
      url: `../login/login?web=home&web_url=${encodeURIComponent(urlLink)}&register_plat=11`
    })
  })
}
// 注册方法给安卓调用
function connectWebViewJavascriptBridge (callback) {
  if (window.WebViewJavascriptBridge) {
    callback(window.WebViewJavascriptBridge);
  } else {
    document.addEventListener("WebViewJavascriptBridgeReady", function () {
      callback(WebViewJavascriptBridge)
    }, false)
  }
}
connectWebViewJavascriptBridge(function (bridge) {
  if (Is.android()) {
    bridge.init(function (message, responseCallback) {
      console.log('默认接收收到来自Java数据： ' + message);
      var responseData = '默认接收收到来自Java的数据，回传数据给你';
      responseCallback(responseData);
    });
  }
  bridge.registerHandler("pushToProductDetail", function (data, responseCallback) {
    var responseData = '指定接收收到来自Java的数据，回传数据给你';
    if(window.location.href && (window.location.href.indexOf("Record") > -1 || window.location.href.indexOf("record") > -1)) {
      if(document.getElementById("appBackBtn"))
        document.getElementById("appBackBtn").click()
    } else {
    }
    responseCallback(responseData);
  });
})

export function formatPrice (price) {
  var decimalsPrice = '';
  var integerPrice = '';
  var decimals = price.toString().split(".");
  integerPrice = decimals[0];
  if (decimals.length > 1) {
    decimalsPrice = decimals[1];
    if (decimals[1].length === 1) {
      decimalsPrice = decimalsPrice + '0'
    }
  } else {
    decimalsPrice = "00";
  }
  return {
    integerPrice: integerPrice,
    decimalsPrice: decimalsPrice
  }
}

// let data = {
//   token: this.token,
//   appletHasToken: '',
//   appletNoToken: '',
//   weiXinHasToken: '',
//   weiXinNoToken: '',
//   iphoneHasToken: '',
//   iphoneNoToken: '',
//   androidHasToken: '',
//   androidNoToken: '',
//   browserHasToken: '',
//   browserNoToken: ''
// }
export function browserEnvironment (option) {
  option.token = option.token || (option.token = '');
  console.log("到了判断环境")
  console.log("isWeixin---" + isWeixin())
  if (isWeixin()) {
    if (isApplet()) {
      console.log('小程序');
      if (option.token) {
        option.appletHasToken ? Is.function(option.appletHasToken) && option.appletHasToken() : console.log('没有传入方法')
      } else {
        option.appletNoToken ? Is.function(option.appletNoToken) && option.appletNoToken() : appletLogin()
      }
    } else {
      console.log('微信');
      if (option.token) {
        option.weiXinHasToken ? Is.function(option.weiXinHasToken) && option.weiXinHasToken() : console.log('没有传入方法')
      } else {
        option.weiXinNoToken ? Is.function(option.weiXinNoToken) && option.weiXinNoToken() : console.log('没有传入方法,什么事都不做')
      }
    }
  } else {
    if (Is.iphone() && !Is.safari()) { // IOS webView 环境处理逻辑
      console.log('IOS');
      if (option.token) {
        option.iphoneHasToken ? Is.function(option.iphoneHasToken) && option.iphoneHasToken() : console.log('没有传入方法')
      } else {
        option.iphoneNoToken ? Is.function(option.iphoneNoToken) && option.iphoneNoToken() : appLogin()
      }
      // } else if (Is.androidPhone() && Is.androidWebView()) { // android webView 处理逻辑
    } else if (Is.android()) { // android webView 处理逻辑
      console.log('Android');
      if (option.token) {
        option.androidHasToken ? Is.function(option.androidHasToken) && option.androidHasToken() : console.log('没有传入方法')
      } else {
        option.androidNoToken ? Is.function(option.androidNoToken) && option.androidNoToken() : appLogin()
      }
    } else { // web 处理逻辑
      console.log('Web');
      if (option.token) {
        option.browserHasToken ? Is.function(option.browserHasToken) && option.browserHasToken() : console.log('没有传入方法')
      } else {
        option.browserNoToken ? Is.function(option.browserNoToken) && option.browserNoToken() : console.log('没有传入方法')
      }
    }
  }
}

// console.log(`检查当前设备是否为iPhone ${Is.iphone()}`);
// console.log(`检查当前设备是否有ios ${Is.ios()}`);
// console.log(`检查当前浏览器是否为safari ${Is.safari()}`);
// console.log(`检查当前浏览器是否为chrome ${Is.chrome()}`);
// console.log(`检查当前设备是否有Android ${Is.android()}`);
// console.log(`检查当前设备是否为Android手机 ${Is.androidPhone()}`);
// console.log(`检查当前设备是否为Android平板电脑 ${Is.androidTablet()}`)
// console.log(`检查当前设备是否在线 ${Is.online()}`);
// console.log(`检查当前环境是微信 ${Is.weixin()}`);
// console.log(`检查当前环境是小程序环境 ${Is.applet()}`)
export function device () {
  let u = window.navigator.userAgent;
  // android终端
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  // ios终端
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  return {
    android: isAndroid,
    ios: isiOS
  }
}
export function linkApp (params, xcxUrl, h5params) {
  if (isWeixin()) {
    if (window.__wxjs_environment === 'miniprogram') { // 小程序环境下逻辑
      wx.miniProgram.getEnv(function (res) {
        if (h5params === 'gohome') {
          wx.miniProgram.switchTab({
            url: xcxUrl
          })
        } else {
          wx.miniProgram.navigateTo({
            url: xcxUrl
          })
        }
      })
    } else { // 微信环境
    }
  } else {
    let deviceP = device()
    var userAgent = ((navigator && navigator.userAgent) || '').toLowerCase();
    console.log("userAgent")
    console.log(userAgent)
    console.log("Is.android()WebViewJavascriptBridge")
    console.log(window, '1')
    console.log(window.WebViewJavascriptBridge, '2')
    // if ((Is.ios() && Is.iphone()) || (Is.android() && Is.androidPhone())) {
    if (Is.ios() || Is.android()) {
      if (window.webkit) { // IOS
        console.log("IOS -----")
        window.webkit.messageHandlers.pushToProductDetail.postMessage(params)
        return false;
      }
      if (window.WebViewJavascriptBridge) { // Android
        console.log("Android -----")
        window.WebViewJavascriptBridge.callHandler('pushToProductDetail', params, function responseCallback (responseData) {
          console.log("回调成功");
        })
        console.log(111);
        return false;
      }
    } else if (Is.safari()) {
      console.log("safari -----")
      const option = {
        scheme: {
          protocol: 'funengdaWaterUser'
        },
        intent: {
          package: '',
          scheme: ''
        },
        appstore: 'https://itunes.apple.com/cn/app/id1372636061?mt=8',
        fallback: 'https://activity.fndwater.com/download.html',
        timeout: 2000
      };
      const lib = new CallApp(option);
      lib.open({
        path: h5params,
        callback: function () {
          window.location.href = 'https://activity.fndwater.com/download.html'
        }
      });
    }
  }
}

export function countdown (beginTime, index, callBack) {
  // 获取当前时间
  var date = new Date();
  var now = date.getTime();
  // 设置截止时间
  var endDate = new Date("2018-10-22 23:23:23");
  var end = endDate.getTime();
  // 时间差
  var leftTime = end - now;
  // 定义变量 d,h,m,s保存倒计时的时间
  if (leftTime >= 0) {
    this.h = Math.floor(leftTime / 1000 / 60 / 60 % 24);
    this.m = Math.floor(leftTime / 1000 / 60 % 60);
    this.s = Math.floor(leftTime / 1000 % 60);
  }
  console.log(this.s);
  // 递归每秒调用countTime方法，显示动态时间效果
  setTimeout(this.countTime, 1000);
}

// export function openApp (openUrl, callback) {
//   // 检查app是否打开
//   function checkOpen (cb) {
//     var _clickTime = +(new Date());
//     function check (elsTime) {
//       if (elsTime > 3000 || document.hidden || document.webkitHidden) {
//         cb (1); // 己安装App
//       } else {
//         cb (0); // 未安装App
//       }
//     }
//     // 启动间隔20ms运行的定时器，并检测累计消耗时间是否超过3000ms，超过则结束
//     var _count = 0, intHandle;
//     intHandle = setInterval(function () {
//       _count++;
//       var elsTime = +(new Date()) - _clickTime;
//       if (_count >= 100 || elsTime > 3000) {
//         clearInterval(intHandle);
//         check(elsTime);
//       }
//     }, 20);
//   }
//   // 在iframe 中打开APP
//   var ifr = document.createElement('iframe');
//   ifr.src = openUrl;
//   ifr.style.display = 'none';
//
//   if (callback) {
//     // 客户端检测微信直接跳应用宝链接
//     var browser = BrowserInfo;
//     // 使用微链接
//     var encodeUri = encodeURIComponent(openUrl);
//
//     if (browser.isWeixin) {
//       window.location.href = '你的微链url&android_schema=' + encodeUri;
//     } else {
//       checkOpen(function (opened) {
//         callback && callback(opened);
//       });
//     }
//   }
//
//   document.body.appendChild(ifr);
//   setTimeout(function () {
//     document.body.removeChild(ifr);
//   }, 2000);
// }

function Rad (d) {
  return d * Math.PI / 180.0; // 经纬度转换成三角函数中度分表形式。
}

// 获取地图两点间的距离
export function GetDistance (lat1, lng1, lat2, lng2) { // 传入两个点的经纬度
  var radLat1 = Rad(lat1);
  var radLat2 = Rad(lat2);
  var a = radLat1 - radLat2;
  var b = Rad(lng1) - Rad(lng2);
  var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
    Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
  s = s * 6378.137; // EARTH_RADIUS;
  s = Math.round(s * 10000) / 10000; // 输出为公里
  s = s.toFixed(2); // 保留小数点后两位小数
  return s;
}

// 计算指定日期前n天的开始日期
export function getBeforeDate (date, n) {
  var n = n - 1;
  var d = date;
  var year = d.getFullYear();
  var mon = d.getMonth() + 1;
  var day = d.getDate();
  if (day <= n) {
    if (mon > 1) {
      mon = mon - 1;
    } else {
      year = year - 1;
      mon = 12;
    }
  }
  d.setDate(d.getDate() - n);
  year = d.getFullYear();
  mon = d.getMonth() + 1;
  day = d.getDate();
  var s = year + "年" + (mon < 10 ? ('0' + mon) : mon) + "月" + (day < 10 ? ('0' + day) : day) + '日';
  //  var s = {year:year,mon:mon<10?('0'+mon):mon,day:(day<10?('0'+day):day)};
  return s;
}

// 计算指定日期后n天的开始日期
export function getEndDate (date, n) {
  var n = n - 1;
  var d = date;
  var year = d.getFullYear();
  var mon = d.getMonth() + 1;
  var day = d.getDate();
  if (day <= n) {
    if (mon > 1) {
      mon = mon - 1;
    } else {
      year = year - 1;
      mon = 12;
    }
  }
  d.setDate(d.getDate() + n);
  year = d.getFullYear();
  mon = d.getMonth() + 1;
  day = d.getDate();
  var s = year + "年" + (mon < 10 ? ('0' + mon) : mon) + "月" + (day < 10 ? ('0' + day) : day) + '日';
  //  var s = {year:year,mon:mon<10?('0'+mon):mon,day:(day<10?('0'+day):day)};
  return s;
}
